export const columns = function () {
    return [
        {
            prop: 'orgName',
            label: '机构',
            minWidth: 200
        },
        {
            prop: 'rateRegion',
            label: '地区',
            minWidth: 100
        },
        {
            prop: "handle",
            label: "操作",
            minWidth: 100,
        }

    ]
}

/**
 * 表单相关
 */
// 添加地区
export const regionFormOption = function() {
  return [
    {
      prop: 'orgName',
      label: '机构名称',
      type: 'input',
	  disabled: true
    },
    {
      prop: 'rateRegion',
      label: '地区',
      type: 'select',
      options: this.classOptions
    }
  ]
}

/**
 * 校验相关 
 */
export const rules = function(self) {
  return {
    rateRegion: [
      { required: true, message: '请选择地区', trigger: ['change', 'blur']}
    ]
  }
}
export default {}